
export default () => {

    function updateScrollBar(){

        var providersCount = $('.provider-col').length;
        var windowsWidth = $(window).width();

        if((providersCount > 4) || (windowsWidth < 1200)){

            $('.provider_sites__grid .row').mCustomScrollbar("update");
            $('.provider_sites__grid .row').mCustomScrollbar({
                axis:"x",
                theme:"dark-thin",
                autoExpandScrollbar:true,
                advanced:{
                    autoExpandHorizontalScroll:true,
                    updateOnContentResize: true
                },
                scrollbarPosition: "outside",
            });
        }else {
            $('.provider_sites__grid .row').mCustomScrollbar("disable");
        }

    }

    updateScrollBar();

    $(window).on('resize', function(){
        updateScrollBar();
    });

}
